module.exports = __webpack_public_path__ + "static/flags/BY-3d0eb8112bf45577cf7423a7d8d6446d.gif";